import React, { createRef, Component } from "react";
import Lottie from "lottie-react";
import "styled-components/macro";

import lottieCode from "./lottie/code.json";
import imgLogo from "./images/logo-w-lts-badge-grayed.svg";
import OpenSourceOval from "./images/open-source-oval.svg";

export default class BonusFeaturesFOSS extends Component {
  initialState = {
    isHovered: false,
  };
  state = this.initialState;
  timers = [];
  animationMs = 500;
  animationDelayMs = 250;
  svgWidth = 700;
  refLottie = createRef();
  render() {
    return (
      <div
        onMouseEnter={this.startAnimation}
        onMouseLeave={this.resetAnimation}
        css={`
          position: relative;
          display: inline-flex;
          margin: 16px 0 0;
          width: 66%;
          height: 500px;
          color: white;
          cursor: grab;
          border-radius: 15.0px;
          overflow: hidden;
          background-color: hsl(240 11% 95% / 1);
          box-shadow: 2.5px 2.2px 0px 0.5px hsl(240deg 8% 90%);
          border: 1px solid hsl(0deg 0% 54% / 40%);
          filter: brightness(1.07);
          transition: filter 140ms ease-out;
          &:hover {
            box-shadow: none;
            filter: brightness(1);
          }
        `}
      >
        <div
          css={`
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 50%;
          `}
        >
          <div
            css={`
              padding: 39px 0 0 39px;
              font-weight: 600;
              font-size: 14px;
              color: hsl(240 50% 55% / 1);
            `}
          >
            OPEN SOURCE
          </div>
          <div
            css={`
              margin-top: 190px;
              font-size: 24px;
              line-height: 122%;
              padding: 0 0 39px 39px;
            `}
          >
            <div
              css={`
                font-size: 21px;
                color: hsl(240 10% 35% / 1);
              `}
            >
              <img
                src={imgLogo}
                css={`
                  width: 109.33px;
                  height: 20.69px;
                `}
              />
              {/* <strong>Deploy Your Own Instance</strong> */}
            </div>
            <div
              css={`
                line-height: 133.5%;
                font-size: 18px;
                color: hsl(240 10% 60% / 1);
              `}
            >
              The Long-Term Support release can be used to self-host your own instance. Runs on Node.js, MongodDB, and any modern browser. Coming early-2025.
            </div>
          </div>
        </div>
        <div
          css={`
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50%;
          `}
        >
          <div
            css={`
              filter: ${this.state.isHovered
                ? "saturate(1) brightness(1) opacity(1)"
                : "saturate(0) brightness(1) opacity(0.7)"};
              transition: filter 150ms ease-out;
            `}
          >
            <Lottie
              lottieRef={this.refLottie}
              style={{
                width: this.svgWidth,
              }}
              autoplay={false}
              animationData={lottieCode}
            />
          </div>
          <div
            css={`
              position: absolute;
              top: ${this.svgWidth * 0.46}px;
              left: ${this.svgWidth * 0.36}px;
            `}
          >
            <img src={OpenSourceOval} />
          </div>
        </div>
      </div>
    );
  }

  startAnimation = () => {
    this.refLottie.current.play();
    this.setState({ isHovered: true });
  };

  resetAnimation = () => {
    this.refLottie.current.pause();
    this.setState({ isHovered: false });
  };

  calcTransition = (device) => {
    if (device === "googlepixel")
    {
      return `filter ${this.animationMs}ms ease-out`;
    } else if (device === "iphone12")
    {
      return `filter ${this.animationMs}ms ease-out`;
    }
  };
}
